import { Controller } from "@hotwired/stimulus"

const PREFERRED_BORDER_COLOR = "#9EC3C6"

export default class extends Controller {
  static values = { id: Number }
  static targets = ["select", "indicator", "inputBorder"]

  declare idValue: number
  declare selectTarget: HTMLSelectElement
  declare indicatorTarget: HTMLElement
  declare hasIndicatorTarget: boolean
  declare inputBorderTarget: HTMLElement
  declare hasInputBorderTarget: boolean

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  private sync() {
    const isMatch = this.isPreferredSelected()

    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.display = isMatch ? "" : "none"
    }

    this.applyBorder()
  }

  private applyBorder() {
    if (!this.hasInputBorderTarget) return

    if (this.isPreferredSelected()) {
      this.inputBorderTarget.style.borderColor = PREFERRED_BORDER_COLOR
    } else {
      this.inputBorderTarget.style.borderColor = ""
    }
  }

  private isPreferredSelected(): boolean {
    return parseInt(this.selectTarget.value, 10) === this.idValue
  }
}
